const TABLET_USER_AGENT_REGEX = /Tablet|iPad|PlayBook|Silk/i;
const MOBILE_USER_AGENT_REGEX =
  /Mobile|iPhone|iPod|Android|BlackBerry|IEMobile|Opera Mini/i;

const DOMAIN_SEGMENT_START = 0;
const DOMAIN_SEGMENT_OFFSET = -2;
const ADULT_AGE_YEARS = 18;

export const getFirstSegmentFromDomain = () => {
  const host = globalThis.window.location.hostname;

  return host === "znanierussia.ru"
    ? host
    : host
        .split(".")
        .slice(DOMAIN_SEGMENT_START, DOMAIN_SEGMENT_OFFSET)
        .join(".");
};

export const isAdult = (date: Date | undefined) => {
  if (!date) {
    return true;
  }

  const today = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const adultYear = year + ADULT_AGE_YEARS;
  const adultDate = new Date(adultYear, month, day);

  return today >= adultDate;
};

export const getDeviceType = () => {
  let deviceType = "unknown";
  const userAgent = navigator.userAgent;

  if (userAgent) {
    const isTablet = TABLET_USER_AGENT_REGEX.test(userAgent);
    const isMobile = MOBILE_USER_AGENT_REGEX.test(userAgent);

    switch (true) {
      case isTablet: {
        deviceType = "tablet";
        break;
      }
      case isMobile: {
        deviceType = "mobile";
        break;
      }
      default: {
        deviceType = "desktop";
      }
    }
  }

  return deviceType;
};
